/* eslint-disable */
/** AUTO-GENERATED by npm run import-projects - do not edit by hand */
import type { ProjectRecordBase } from './projects.types';

export const generatedProjects: ProjectRecordBase[] = [
  {
    "id": "borderhouse-brewing-company",
    "title": "Borderhouse Brewing Company",
    "type": "Commercial-Restaurant-Historic Structure",
    "typeCategory": "commercial",
    "squareFeet": 6000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Crystal Bay, NV",
    "status": "completed",
    "mapLocation": 1
  },
  {
    "id": "tahoe-biltmore-hotel-and-casino",
    "title": "Tahoe Biltmore Hotel and Casino",
    "type": "Commercial-Hotel and Casino - Reposition-Tear down",
    "typeCategory": "hotel",
    "squareFeet": 50000,
    "units": 60,
    "role": "Broker-Developer",
    "location": "Crystal Bay, NV",
    "status": "completed",
    "mapLocation": 2
  },
  {
    "id": "tahoe-mariner-hotel-and-casino",
    "title": "Tahoe Mariner Hotel and Casino",
    "type": "Hotel-Casino Site-Development Rights-Settlement",
    "typeCategory": "hotel",
    "squareFeet": 20000,
    "units": 32,
    "role": "Broker-Developer",
    "location": "Crystal Bay, NV",
    "status": "completed",
    "mapLocation": 3
  },
  {
    "id": "bal-tabarin-hotel-casino-crystal-view-condos",
    "title": "Bal Tabarin Hotel-Casino-Crystal View Condos",
    "type": "Mixed Use Commercial-Residential",
    "typeCategory": "mixedUse",
    "squareFeet": 8000,
    "units": 24,
    "role": "Broker-Co-Developer",
    "location": "Crystal Bay, NV",
    "status": "completed",
    "mapLocation": 4
  },
  {
    "id": "red-cedar-estates",
    "title": "Red Cedar Estates",
    "type": "Townhomes",
    "typeCategory": "residential",
    "squareFeet": 10000,
    "units": 4,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 4
  },
  {
    "id": "570-lakeshore-dr",
    "title": "570 Lakeshore Dr.",
    "type": "Commercial Office",
    "typeCategory": "commercial",
    "squareFeet": 6000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 5
  },
  {
    "id": "590-lakeshore-dr",
    "title": "590 Lakeshore Dr.",
    "type": "Commercial Office",
    "typeCategory": "commercial",
    "squareFeet": 8000,
    "units": 4,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 6
  },
  {
    "id": "village-plaza-gas-station-site-conversion",
    "title": "Village Plaza - Gas Station site conversion",
    "type": "Commercial-Retail",
    "typeCategory": "commercial",
    "squareFeet": 30000,
    "units": 12,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 7
  },
  {
    "id": "aspen-plaza",
    "title": "Aspen Plaza",
    "type": "Commercial-Office",
    "typeCategory": "commercial",
    "squareFeet": 8000,
    "units": 10,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 8
  },
  {
    "id": "pine-ridge-plaza",
    "title": "Pine Ridge Plaza",
    "type": "Commercial Office",
    "typeCategory": "commercial",
    "squareFeet": 12000,
    "units": 16,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 9
  },
  {
    "id": "timber-ridge-plaza",
    "title": "Timber Ridge Plaza",
    "type": "Commercial Office",
    "typeCategory": "commercial",
    "squareFeet": 6000,
    "units": 6,
    "role": "Broker-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 10
  },
  {
    "id": "hyatt-timeshare-vacation-club",
    "title": "Hyatt Timeshare Vacation Club",
    "type": "Hotel-Tourist",
    "typeCategory": "hotel",
    "squareFeet": 120000,
    "units": 62,
    "role": "Broker-Consultant",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 11
  },
  {
    "id": "country-club-villas",
    "title": "Country Club Villas",
    "type": "Residential - Townhomes",
    "typeCategory": "residential",
    "squareFeet": 120000,
    "units": 50,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 12
  },
  {
    "id": "lake-country-estates",
    "title": "Lake Country Estates",
    "type": "Residential Townhomes",
    "typeCategory": "residential",
    "squareFeet": 70000,
    "units": 24,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 13
  },
  {
    "id": "golf-course-villas-iv-champ-course",
    "title": "Golf Course Villas-IV Champ Course",
    "type": "Residential Townhomes",
    "typeCategory": "residential",
    "squareFeet": 45000,
    "units": 14,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 14
  },
  {
    "id": "southwood-villas",
    "title": "Southwood Villas",
    "type": "Residential Townhomes",
    "typeCategory": "residential",
    "squareFeet": 15000,
    "units": 4,
    "role": "Broker-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 15
  },
  {
    "id": "work-force-housing-incline-way",
    "title": "Work Force Housing - Incline Way",
    "type": "Residential - Townhomes",
    "typeCategory": "residential",
    "squareFeet": 20000,
    "units": 18,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 16
  },
  {
    "id": "workforce-housing-northwood-blvd",
    "title": "Workforce Housing - Northwood Blvd.",
    "type": "Residential - Townhomes",
    "typeCategory": "residential",
    "squareFeet": 22000,
    "units": 12,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 17
  },
  {
    "id": "incline-creek-estates",
    "title": "Incline Creek Estates",
    "type": "Residential - Townhomes",
    "typeCategory": "residential",
    "squareFeet": 150000,
    "units": 50,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 18
  },
  {
    "id": "346-winding-way",
    "title": "346 Winding Way",
    "type": "SFR-Custom",
    "typeCategory": "residential",
    "squareFeet": 3200,
    "units": 1,
    "role": "GP-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 19,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "1308-1310-uri-ct",
    "title": "1308-1310 Uri Ct.",
    "type": "Duplex - MFR",
    "typeCategory": "residential",
    "squareFeet": 5000,
    "units": 2,
    "role": "GP-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 20
  },
  {
    "id": "1412-14-styria",
    "title": "1412-14 Styria",
    "type": "Tri-Plex - MFR",
    "typeCategory": "residential",
    "squareFeet": 12000,
    "units": 3,
    "role": "GP-Co-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 21
  },
  {
    "id": "1424-tirol",
    "title": "1424 Tirol",
    "type": "SFR - Custom",
    "typeCategory": "residential",
    "squareFeet": 4000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 22,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "ridgeview-estates",
    "title": "Ridgeview Estates",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 13000,
    "units": 4,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 23,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "850-freels-peak",
    "title": "850 Freels Peak",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 5000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 24,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "824-ophir-peak",
    "title": "824 Ophir Peak",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 5000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 25,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "126-rubicon-peak",
    "title": "126 Rubicon Peak",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 4500,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 26,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "573-valley-ct",
    "title": "573 Valley Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3400,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 27,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "574-valley-ct",
    "title": "574 Valley Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3200,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 28,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "812-ellen-ct",
    "title": "812 Ellen Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3600,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 29,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "814-ellen-ct",
    "title": "814 Ellen Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3600,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 30,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "684-bridger-ct",
    "title": "684 Bridger Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 2300,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 31,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "990-hook-ct",
    "title": "990 Hook Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 4400,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 32,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "105-5th-green-ct",
    "title": "105 5th Green Ct.",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3000,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 33,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "570-n-dyer",
    "title": "570 N. Dyer",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3800,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 34,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "854-freels-peak",
    "title": "854 Freels Peak",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 4200,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 35,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "967-cinnabar",
    "title": "967 Cinnabar",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 2800,
    "units": 1,
    "role": "GP-Developer",
    "location": "Incline Village, NV",
    "status": "completed",
    "mapLocation": 36,
    "groupKey": "incline-sfr-custom"
  },
  {
    "id": "346-thunderbird-circle-martis-camp",
    "title": "346 Thunderbird Circle-Martis Camp",
    "type": "SFR Custom",
    "typeCategory": "residential",
    "squareFeet": 3200,
    "units": 1,
    "role": "GP-Developer",
    "location": "Truckee, CA",
    "status": "completed",
    "mapLocation": null
  },
  {
    "id": "indian-hills-center",
    "title": "Indian Hills Center",
    "type": "Commercial-Retail",
    "typeCategory": "commercial",
    "squareFeet": 20000,
    "units": 12,
    "role": "GP-Developer",
    "location": "Carson Valley, NV",
    "status": "completed",
    "mapLocation": null
  },
  // {
  //   "id": "chateau-at-the-village",
  //   "title": "Chateau at the Village",
  //   "type": "Hotel-Condo-Mixed Use - Resort",
  //   "typeCategory": "mixedUse",
  //   "squareFeet": 200000,
  //   "units": 387,
  //   "role": "Developer-Consultant",
  //   "location": "South Lake Tahoe, CA",
  //   "status": "pending",
  //   "mapLocation": null
  // },
  {
    "id": "legacy-club-mccall-id",
    "title": "Legacy Club - McCall, ID",
    "type": "Mixed Use Sustainable Resort and Residence Club",
    "typeCategory": "mixedUse",
    "squareFeet": null,
    "units": null,
    "role": "Developer-Consultant",
    "location": "Central Idaho",
    "status": "pending",
    "mapLocation": null
  }
];

export const generatedCategoryLabels = {
  "commercial": "Commercial",
  "hotel": "Hotel & resort",
  "mixedUse": "Mixed use",
  "residential": "Residential"
} as const;
